import { UseFormReturnType } from '@mantine/form';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router';
import { FormValuesType } from 'src/UI/dynamicUI/types';

// Defaults the joint-ownership toggle from the owner-selection step: two or more
// selected owners arrive as `joint=true`, a single owner as `joint=false`. Only
// applied on create so editing an existing item never has its value overwritten.
export function useJointOwnerDefault(
  form: UseFormReturnType<FormValuesType>,
  product: string,
  isCreateMode: boolean,
) {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const joint = searchParams.get('joint');
    if (joint !== null && isCreateMode) {
      form.setFieldValue(`${product}.is_joint`, joint === 'true' ? 'true' : 'false');
    }
  }, [searchParams, isCreateMode, product, form]);
}
